import { gql } from "graphql-request";

// 목록·상세 공통 — 응모자/응모자 정보/원고 메타까지 한 번에. consents 는 detail 에서만.
const SUBMISSION_LIST_FIELDS = `
  _id
  contestId
  userId
  userEmail
  userName
  name
  penName
  birthdate
  email
  phone
  emergencyPhone
  snsUrl
  workTitle
  keywords
  submittedAt
  createdAt
  updatedAt
  manuscript {
    s3Key
    originalFilename
    size
    contentType
  }
  charCount {
    status
    value
    extractedAt
    errorCode
  }
  screening {
    result
    memo
    checklist {
      key
      value
    }
    reviewerEmail
    reviewedAt
  }
`;

export const ADMIN_CONTEST_SUBMISSIONS = gql`
  query AdminContestSubmissions($input: AdminContestSubmissionsInputDto!) {
    adminContestSubmissions(input: $input) {
      items {
        ${SUBMISSION_LIST_FIELDS}
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

// detail 은 시놉시스·줄거리·약관 동의까지 전체 — drawer 에서 ReadonlyBlock 으로 렌더.
export const ADMIN_CONTEST_SUBMISSION_DETAIL = gql`
  query AdminContestSubmissionDetail($submissionId: String!) {
    adminContestSubmissionDetail(submissionId: $submissionId) {
      _id
      contestId
      userId
      userEmail
      userName
      name
      penName
      birthdate
      email
      phone
      emergencyPhone
      snsUrl
      workTitle
      synopsis
      summary
      logline
      setting
      characters
      keywords
      consents {
        privacy
        terms
        pledge
        consentedAt
        version
      }
      manuscript {
        s3Key
        originalFilename
        size
        contentType
      }
      charCount {
        status
        value
        extractedAt
        errorCode
      }
      screening {
        result
        memo
        checklist {
          key
          value
        }
        reviewerEmail
        reviewedAt
      }
      reviewNotes {
        field
        note
        updatedBy
        updatedAt
      }
      submittedAt
      createdAt
      updatedAt
    }
  }
`;

/** 심사 진행 현황 — 목록 상단 대시보드 카드/진행률용. */
export const ADMIN_CONTEST_SCREENING_STATS = gql`
  query AdminContestScreeningStats {
    adminContestScreeningStats {
      total
      pass
      fail
      pending
      reviewedCount
    }
  }
`;
